import React from "react";
import { MessageDescriptor } from "react-intl";

import { Slider } from "src/common/components/Slider";
import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import {
	useLogProp,
	useMessageProps,
	useValue
} from "src/features/forms/hooks/useField";
import { SliderProps } from "src/features/forms/types";

export const SliderRenderer: React.FunctionComponent<SliderProps> = ({
	labels,
	...directProps
}) => {
	const isLocked = React.useContext(IsLockedContext);
	const options = useOptions(labels);
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<Slider
			{...directProps}
			disabled={isLocked}
			options={options}
			value={value}
			onChangeValue={onChangeValue}
		/>
	);
};

function useOptions(messages: {
	[key: string]: MessageDescriptor;
}): { label: string; value: string }[] {
	const formatMessage = useFormatMessageMap();
	const messageProps = useMessageProps();
	const values = useLogProp<string[]>(messageProps, "values", []);
	return React.useMemo(
		() =>
			values.map(value => ({
				label: formatMessage(messages, value),
				value
			})),
		[messages, values, formatMessage]
	);
}
